import React from 'react'
import { View, ViewStyle, Image } from 'react-native'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import Divider from '@mui/material/Divider'
import { color } from '../../theme'
import { Medallion } from '../medallion'
import { Text } from '../text'
import { IMSTArray } from 'mobx-state-tree'
import { UserCertificationCriteria } from '@trivie/core/src/models/UserTopicDetails'

interface CertificationTooltipProps {
  handleClose: () => void
  visible: boolean
  anchorRef?: any
  criteria?: IMSTArray<typeof UserCertificationCriteria>
  badge?: any
}

export const CertificationTooltip = (props: CertificationTooltipProps) => {
  const { handleClose, badge, criteria, anchorRef, visible } = props

  return (
    <Popper
      aria-label="Certification criteria"
      open={visible}
      anchorEl={anchorRef?.current}
      role={undefined}
      transition
    >
      {({ TransitionProps, placement }) => (
        <Grow
          timeout={{ appear: 200, enter: 200, exit: 200 }}
          {...TransitionProps}
          style={{
            zIndex: 9999,
            transformOrigin: placement === 'bottom' ? 'center top' : 'center left',
          }}
        >
          <Paper
            aria-label="Certification criteria"
            style={{ boxShadow: 'none', background: 'transparent' }}
          >
            <ClickAwayListener onClickAway={handleClose}>
              <View style={CONTAINER}>
                {badge && criteria ? (
                  <>
                    <div
                      style={{
                        flexDirection: 'column',
                        display: 'flex',
                        alignItems: 'center',
                        borderBottom: `1px solid ${color.shade10}`,
                        marginBottom: 24,
                      }}
                    >
                      <Text
                        style={{ marginBottom: 24 }}
                        variant="labelEmphasized"
                        text="Awards Available"
                      />
                      <Image
                        style={{
                          width: 120,
                          height: 120,
                          borderRadius: 100,
                          margin: 24,
                          opacity: 0.7,
                        }}
                        source={{ uri: badge?.icon_url }}
                      />
                      <Text variant="body1Emphasized" text={badge.label} />
                      <Text
                        style={{ color: '#9098A3', marginBottom: 24 }}
                        variant="body1"
                        text={badge.description}
                      />
                    </div>
                    <div
                      style={{
                        flexDirection: 'column',
                        display: 'flex',
                      }}
                    >
                      <Text
                        style={{ color: '#9098A3', marginBottom: 24, alignSelf: 'center' }}
                        variant="body2Medium"
                        text="Earn medals to get certified"
                      />
                      <View style={{ left: 0, top: 12 }}>
                        {criteria &&
                          criteria.map((c) => {
                            return (
                              <View style={{ flexDirection: 'row', marginBottom: 24 }}>
                                <Medallion
                                  style={{ position: 'absolute', left: -32, bottom: -24 }}
                                  scale={0.34}
                                  type={c.level}
                                />
                                <View style={{ flexDirection: 'column', right: -48, bottom: 12 }}>
                                  <Text variant="body2Emphasized" text={c.level} />
                                  <Text
                                    variant="body2Medium"
                                    style={{ color: '#9098A3' }}
                                    text={c.criteria}
                                  />
                                </View>
                              </View>
                            )
                          })}
                      </View>
                    </div>
                  </>
                ) : badge ? (
                  <>
                    <Text
                      style={{ marginBottom: 24, alignSelf: 'center' }}
                      variant="labelEmphasized"
                      text="Badge Available"
                    />
                    <Image
                      style={{
                        width: 120,
                        height: 120,
                        borderRadius: 100,
                        alignSelf: 'center',
                        marginBottom: 24,
                        opacity: 0.7,
                      }}
                      source={{ uri: badge?.icon_url }}
                    />
                    <Text
                      style={{ alignSelf: 'center' }}
                      variant="body1Emphasized"
                      text={badge?.label}
                    />
                    <Text
                      style={{ color: '#9098A3', alignSelf: 'center', marginBottom: 24 }}
                      variant="body1"
                      text={badge?.description}
                    />
                  </>
                ) : criteria ? (
                  <>
                    <Text
                      style={{ marginBottom: 4, alignSelf: 'center' }}
                      variant="labelEmphasized"
                      text="Certification Available"
                    />
                    <Text
                      style={{ color: '#9098A3', marginBottom: 24, alignSelf: 'center' }}
                      variant="body2Medium"
                      text="Earn medals to get certified"
                    />
                    <View style={{ left: 0, top: 12 }}>
                      {criteria &&
                        criteria.map((c) => {
                          return (
                            <View style={{ flexDirection: 'row', marginBottom: 24 }}>
                              <Medallion
                                style={{ position: 'absolute', left: -32, bottom: -24 }}
                                scale={0.34}
                                type={c.level}
                              />
                              <View style={{ flexDirection: 'column', right: -48, bottom: 12 }}>
                                <Text variant="body2Emphasized" text={c.level} />
                                <Text
                                  variant="body2Medium"
                                  style={{ color: '#9098A3' }}
                                  text={c.criteria}
                                />
                              </View>
                            </View>
                          )
                        })}
                    </View>
                  </>
                ) : null}
              </View>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}

const CONTAINER: ViewStyle = {
  zIndex: 999,
  // right: 188,
  width: 430,
  // top: -20,
  backgroundColor: color.white,
  shadowColor: '#000',
  shadowRadius: 6,
  shadowOpacity: 0.2,
  shadowOffset: { height: 0, width: 0 },
  borderRadius: 20,
  paddingTop: 28,
  paddingHorizontal: 24,
}
